<template>
  <div class="min-h-screen flex flex-col items-center">

    <!-- Account Info -->
<!--    <div v-if="account" class="mb-4 w-full bg-white p-4 rounded-md shadow-sm">-->
<!--      <p class="text-sm"><strong>Account Name:</strong> {{ account.account_name }}</p>-->
<!--      <p class="text-sm"><strong>Account Number:</strong> {{ account.account_number }}</p>-->
<!--      <p class="text-sm"><strong>Accounting Balance:</strong> {{ account.accounting_balance }}</p>-->
<!--      <p class="text-sm"><strong>Available Balance:</strong> {{ account.available_balance }}</p>-->
<!--    </div>-->

    <!-- Filter Card -->
    <div class="w-full">

      <button
          @click="toggle"
          :aria-expanded="isOpen"
          class="w-full flex items-center justify-between px-4 py-3 bg-white rounded-md hover:shadow-sm transition">
        <div class="flex items-center gap-3">
          <span v-if="!isSubmitted" class="text-sm text-gray-700 font-semibold">
            PROCESSING - ALL DATES
          </span>
          <span v-else class="text-sm text-primary font-semibold">
            {{ form.viewType.toUpperCase() }} - {{ form.dateRange }}
          </span>
        </div>
        <svg
            class="w-5 h-5 transform transition-transform duration-200"
            :style="{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none" viewBox="0 0 24 24" stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      <!-- Collapsible content -->
      <transition
          enter-active-class="transition-all duration-300 ease-out"
          leave-active-class="transition-all duration-250 ease-in"
          enter-from-class="opacity-0 -translate-y-2 max-h-0"
          enter-to-class="opacity-100 translate-y-0 max-h-96"
          leave-from-class="opacity-100 translate-y-0 max-h-96"
          leave-to-class="opacity-0 -translate-y-2 max-h-0"
      >
        <div v-show="isOpen" ref="contentRef" class="mt-4">

          <!-- Filter Fields (مثل قبل) -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div class="relative">
              <FloatingLabelSelect v-model="form.viewType" label="View Type">
                <option value="processing">Processing</option>
                <option value="pending">Pending Authorization</option>
                <option value="history">History</option>
              </FloatingLabelSelect>

            </div>
            <div class="relative">
              <FloatingLabelSelect v-model="form.dateRange" label="All dates">
                <option value="all">All Dates</option>
                <option value="ytd">Year to Date</option>
                <option value="last_30_days">Last 30 Days</option>
                <option value="last_7_days">Last 7 Days</option>
              </FloatingLabelSelect>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div class="relative">
              <FloatingLabelSelect v-model="form.txType" label="Transaction Type">
                <option value="all">All</option>
                <option value="cancel-pending-transfer">Cancel Pending Transfer Order</option>
                <option value="send-files">Send Files</option>
                <option value="redeem-product">Redeem Product</option>
                <option value="payment-services">Payment of Services</option>
                <option value="deposit-assets">Deposit Digital Assets</option>
              </FloatingLabelSelect>

            </div>
<!--            <div class="flex items-center gap-3">-->
<!--              <input type="text" placeholder="Enter a date range" class="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-500">-->
<!--              <button class="p-3 border rounded-lg border-gray-300 bg-gray-100 hover:bg-gray-200">📅</button>-->
<!--            </div>-->

            <div class="flex gap-3 items-center">
              <!-- Radio برای انتخاب preset/custom -->
              <input type="radio" id="preset" value="preset" v-model="dateMode">
              <label for="preset">Preset</label>

              <input type="radio" id="custom" value="custom" v-model="dateMode">
              <label for="custom">Custom</label>

              <!-- اگر custom انتخاب شد، datepicker نمایش داده شود -->
              <flat-pickr
                  v-if="dateMode === 'custom'"
                  v-model="form.dateRangeCustom"
                  :config="fpConfig"
                  placeholder="Select date range"
                  class="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div class="relative">
              <FloatingLabelSelect v-model="form.comparator" label="Comparator">
                <option value="=">Equal (=)</option>
                <option value=">">Greater Than (&gt;)</option>
                <option value="&gt;=">Greater or Equal (&gt;=)</option>
                <option value="<">Less Than (&lt;)</option>
                <option value="&lt;=">Less or Equal (&lt;=)</option>
              </FloatingLabelSelect>


            </div>
            <FloatingLabelInput v-model="form.value" input-id="iban-field" label="Value" />
            <div class="relative">
              <FloatingLabelSelect v-model="form.currency" label="Currency">
                <option value="EUR">Euro (EUR)</option>
                <option value="USD">US Dollar (USD)</option>
                <option value="GBP">British Pound (GBP)</option>
                <option value="CHF">Swiss Franc (CHF)</option>
                <option value="JPY">Japanese Yen (JPY)</option>
              </FloatingLabelSelect>

            </div>
          </div>

          <div class="flex justify-center mb-6">
            <button @click="onList" class="w-1/3 bg-primary hover:bg-orange-600 text-white px-10 py-3 rounded-lg shadow-md font-semibold">
              LIST
            </button>
          </div>
        </div>
      </transition>



      <!-- No results -->
      <p v-if="!isSubmitted" class="text-center text-gray-500">No results found</p>

      <!-- Transaction List -->
      <div v-else class="mt-6 space-y-4">
        <div v-for="(tx, index) in transactions" :key="index" class="bg-white border rounded-md shadow-sm p-4">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div class="shadow p-3 rounded-lg divide-y divide-gray-200">
              <div class="flex items-center justify-between px-2 py-1">
                <p class="text-sm text-primary font-semibold">Date/Time</p>
                <p class="text-gray-800">{{ tx.oper_date }}</p>
              </div>
              <div class="flex items-center justify-between px-2 py-1">
                <p class="text-sm text-primary font-semibold mt-2">User</p>
                <p class="text-gray-800">{{ tx.beneficiary.description }} ({{tx.beneficiary.account_number}})</p>
              </div>
              <div class="flex items-center justify-between px-2 py-1">
                <p class="text-sm text-primary font-semibold mt-2">Transaction Type</p>
                <p class="text-gray-800">{{ tx.transaction_type }}</p>
              </div>
            </div>

            <div class="shadow p-3 rounded-lg divide-y divide-gray-200">
              <div class="flex items-center justify-between px-2 py-1">
                <p class="text-sm text-primary font-semibold">Sort nr.</p>
                <p class="text-gray-800">{{ tx.doc_no }}</p>
              </div>
              <div class="flex items-center justify-between px-2 py-1">
                <p class="text-sm text-primary font-semibold mt-2">Status</p>
                <p class="text-gray-800">{{ tx.status }}</p>
              </div>
              <div class="flex items-center justify-between px-2 py-1">
                <p class="text-sm text-primary font-semibold mt-2">Value</p>
                <p class="text-gray-800">{{ tx.value }}</p>
              </div>
            </div>
          </div>
          <div class="flex justify-center">
            <button @click="openDetail(tx)" class="bg-primary text-white w-1/4 text-center py-2 rounded-md font-semibold">
              DETAIL
            </button>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal جزئیات -->
    <transition name="fade">
      <div v-if="showDetailModal" class="fixed inset-0 flex items-center justify-center bg-gray-700 bg-opacity-50 z-50 overflow-auto" @click.self="closeDetailModal">
        <div class="bg-white p-6 rounded-lg shadow-lg w-3/5 md:w-4/5 lg:w-3/5 max-h-full overflow-auto">
          <!-- Modal content مثل قبل -->
          <h3 class="text-xl font-semibold text-gray-800 text-center mb-4">DETAIL</h3>
          <pre>{{ detailData }}</pre>
          <div class="mt-4 flex justify-end">
            <button @click="closeDetailModal" class="bg-white hover:bg-gray-100 border border-gray-200 text-primary px-6 py-3 rounded-md shadow">
              <component :is="Printer"/>
            </button>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script setup>
import { ref, reactive,watch,defineEmits } from 'vue'
import { Printer } from 'lucide-vue-next';
import FloatingLabelSelect from '@/components/ui/FloatingLabelSelect.vue';
import FloatingLabelInput from '@/components/ui/FloatingLabelInput.vue';
import api from '@/services/api' // axios instance
import FlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'


const emits = defineEmits(['update-status'])
const pendingCount = ref(0)
const processingCount = ref(0)

const isOpen = ref(false)
const contentRef = ref(null)
const isSubmitted = ref(false)
const account = ref(null)
const transactions = ref([])
const showDetailModal = ref(false)
const detailData = ref({})
const dateMode = ref('preset')

const fpConfig = {
  mode: 'range',
  dateFormat: 'Y-m-d'
}


watch([pendingCount, processingCount], () => {
  emits('update-status', {
    pending: pendingCount.value,
    processing: processingCount.value
  })
})

const form = reactive({
  viewType: '',
  dateMode: '',
  dateRange: '',
  rangeText: '',
  txType: '',
  comparator: '',
  value: '',
  currency: '',
  dateRangeCustom: ''
})

function toggle() {
  isOpen.value = !isOpen.value
}

// Call API for transactions
async function onList() {
  try {
    const res = await api.get('/movements/pending', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: {
        view_type: form.viewType || 'all',
        tx_type: form.txType || 'all',
        dateMode: dateMode.value,
        date_range: form.dateRange, // preset
        date_range_custom: form.dateRangeCustom, // custom
        comparator: form.comparator || '',
        value: form.value || '',
        currency: form.currency || ''
      }
    })

    console.log("dataacc",res.data);

    account.value = res.data.account
    transactions.value = res.data.movements
    isSubmitted.value = true
    isOpen.value = false


    pendingCount.value = Number(res.data.status_counts.pending || 0)
    processingCount.value = Number(res.data.status_counts.processing || 0)

  } catch (err) {
    console.error('Error fetching movements:', err.response?.data || err)
  }
}

function openDetail(tx) {
  detailData.value = { ...tx }
  showDetailModal.value = true
}

function closeDetailModal() {
  showDetailModal.value = false
}

</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
